<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-4"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-4">
    <div v-if="showBanner" class="fixed bottom-0 left-0 right-0 z-50 bg-surface border-t border-border shadow-lg">
      <div class="page-container py-8">
        <div class="flex flex-col gap-8 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex-1">
            <h3 class="text-base font-semibold text-forecolor mb-2">
              {{ $t("We use cookies on our site") }}
            </h3>
            <p class="text-sm text-forecolor">
              {{
                $t(
                  "We use analytical cookies to analyze how visitors use our website. This helps us improve the website and optimize the user experience. The collected data is processed anonymously and not used for other purposes. You can always withdraw or change your consent. To do so, scroll to the bottom of the page and click on 'Cookie Preferences' in the footer."
                )
              }}
            </p>
          </div>

          <div class="flex flex-col sm:flex-row items-start sm:items-center gap-5 shrink-0">
            <div class="flex gap-5">
              <Button @click="acceptAnalytics">
                {{ $t("Accept all") }}
              </Button>
              <Button :variant="'outlined'" @click="declineAnalytics">
                {{ $t("Decline") }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { Button } from "@xs2event/js-lib/components";
import { isB2C } from "@/brandconfig";

const CONSENT_KEY = "cookieConsent";
const PREFERENCES_KEY = "cookiePreferences";

const showBanner = ref(false);

type CookiePreferences = {
  analytics: boolean;
};

const savePreferences = (preferences: CookiePreferences) => {
  localStorage.setItem(PREFERENCES_KEY, JSON.stringify(preferences));
};

onMounted(() => {
  const consent = localStorage.getItem(CONSENT_KEY);

  // If B2B shop, automatically accept analytics cookies
  if (!isB2C) {
    if (!consent) {
      localStorage.setItem(CONSENT_KEY, "accepted");
      savePreferences({ analytics: true });
      window.location.reload();
    }
    return;
  }

  // For B2C shops, show banner if no consent exists
  if (!consent) {
    showBanner.value = true;
  }
});

const acceptAnalytics = () => {
  localStorage.setItem(CONSENT_KEY, "accepted");
  savePreferences({ analytics: true });
  showBanner.value = false;
  window.location.reload();
};

const declineAnalytics = () => {
  // Store explicit decline so we don't keep prompting.
  localStorage.setItem(CONSENT_KEY, "declined");
  savePreferences({ analytics: false });
  showBanner.value = false;
  window.location.reload();
};
</script>
